export const DEFAULT_AMORTIZATION_YEARS_VALUE = "25";
export const DEFAULT_COMPOUNDED_PERIOD_VALUE = "semi-annually";
export const DEFAULT_LOAN_TYPE_VALUE = "mortgage";
export const DEFAULT_COAPP_VALUE = false;
export const DEFAULT_INCLUDE_IN_TDS_VALUE = true;
export const DEFAULT_INCOME_PERIOD_VALUE = "annual";
export const DEFAULT_LANGUAGE_PREFERENCE = "english";
export const DEFAULT_NUM_CHILDREN = "0";
export const DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF = "from-proceeds";
export const FLOWS_FOR_DEFAULT_EXISTING_MORTGAGE_IF_REQUESTED_PAYOFF = ["refinance-approval", "switch-transfer"];